import { StaffReportTable } from './staff-report-table'

export const StaffReportPage = () => {
    return <StaffReportTable />
}
